import React, { useEffect, useState } from 'react'
import CloseSVG from '../../../assets/svg/close.svg'

import FormInput from '../../form-input'
import Modal from '../modal'

function BasicPayrollDetailedView({
  isOpen,
  closeModal,
  viewData,
  previewType,
}) {
  const [payloadData, setPayloadData] = useState(null)
  const [type, setType] = useState(null)
  const [netPay, setNetPay] = useState(null)
  const [id, setId] = useState(null)

  useEffect(() => {
    if (viewData) {
      setPayloadData(viewData)
      setType(previewType)
      setNetPay(viewData.net_pay)
      setId(viewData.id)
    }
  }, [viewData])

  return (
    <Modal
      scrollable={true}
      className='!max-w-[700px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        <div className='form p-3'>
          <div className='px-3'>
            <div className='flex flex-row justify-between'>
              <span className='header-3'>
                {type === 'view' ? 'Basic Payroll' : 'Edit Basic Payroll'}
              </span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col mx-3'>
            <div className='flex flex-col md:flex-col w-full justify-between'>
              {payloadData ? (
                <>
                  <span className='h4-regular text-color-gray'>
                    Employee name
                  </span>
                  <span className='h4-regular text-color-black-2'>
                    {payloadData.employee_first_name}{' '}
                    {payloadData.employee_last_name}
                  </span>
                  <span className='h4-regular text-color-gray mt-2'>
                    Bank Information
                  </span>
                  <span className='h4-regular text-color-black-2'>
                    Bank Name: {payloadData.bank_name} <br />
                    Account Number: {payloadData.account_number}
                    <br />
                    Account Name: {payloadData.account_name}
                  </span>
                  <div className='flex items-center gap-1 mt-2'>
                    <span className='h4-regular text-color-gray'>
                      Amount paid
                    </span>
                    <span className='h4-regular text-color-black-2'>
                      ₦{netPay?.toLocaleString()}{' '}
                    </span>
                  </div>

                  {/* <hr className='divider' /> */}
                  {/* <div className='flex flex-col md:flex-row justify-between'>
                    <div className='w-full md:w-1/2 md:pr-2'>
                      <FormInput
                        label={
                          type === 'view' ? 'Net Pay' : 'Net Pay - Editable'
                        }
                        name='net_pay'
                        type='text'
                        readOnly={type === 'view' ? true : false}
                        value={netPay?.toLocaleString()}
                        onInput={(e) => {
                          setNetPay(e.target.value)
                        }}
                      />
                    </div>
                    <div className='w-full md:w-1/2 md:pr-2'>
                      <FormInput
                        label='Fee'
                        name='net_pay'
                        type='text'
                        readOnly
                        value={payloadData?.trans_cost?.toLocaleString()}
                      />
                    </div>
                  </div> */}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default BasicPayrollDetailedView
